import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-badge-down', 'ArrowBadgeDown', [["path",{"d":"M17 13v-6l-5 4l-5 -4v6l5 4z","key":"svg-0"}]]);